import axios from 'axios';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import { URL } from '../../util/ambienteActions';
import { ATIVAR_HORARIO_EXTRA, INATIVAR_HORARIO_EXTRA } from '../types';

export function ativarHorarioExtra(codigoEmpresa, codigoItinerario) {
    const url = `${URL}/itinerario/${codigoItinerario}/empresa/${codigoEmpresa}/ativar/horario-extra`;

    return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
        type: ATIVAR_HORARIO_EXTRA,
        payload: response
        })
    );
}

export function inativarHorarioExtra(codigoEmpresa, codigoItinerario) {
    const url = `${URL}/itinerario/${codigoItinerario}/empresa/${codigoEmpresa}/inativar/horario-extra`;

    return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
        type: INATIVAR_HORARIO_EXTRA,
        payload: response
        })
    );
}
